import React from "react";
import "../styles/ProcesoContenidoAds.scss";

const steps = [
  {
    num: "01",
    title: "Diagnóstico rápido",
    desc: "Entendemos tu negocio, tu zona y tu objetivo (mensajes, prospectos o ventas).",
    bullets: ["Qué vendes", "A quién", "En qué zona"],
    icon: "🔍",
  },
  {
    num: "02",
    title: "Estrategia + Creativos",
    desc: "Definimos el mensaje y creamos contenido listo para convertir (post + reels según plan).",
    bullets: ["Hooks + CTA", "Diseño pro", "Calendario"],
    icon: "🧠",
  },
  {
    num: "03",
    title: "Campañas en Meta Ads",
    desc: "Montamos y activamos campañas objetivo mensajes, con segmentación y estructura correcta.",
    bullets: ["Audiencias", "Anuncios", "Optimización"],
    icon: "🎯",
  },
  {
    num: "04",
    title: "Optimización y escalamiento",
    desc: "Medimos, ajustamos y repetimos lo que funciona. Si aplica, automatizamos con bot.",
    bullets: ["Ajustes semanales", "Mejor rendimiento", "Escalar"],
    icon: "📈",
  },
];

const ProcesoContenidoAds = () => {
  return (
    <section className="ovit-proc" id="proceso">
      <div className="ovit-proc__bg" aria-hidden="true">
        <div className="ovit-proc__grid" />
        <div className="ovit-proc__glow ovit-proc__glow--1" />
        <div className="ovit-proc__glow ovit-proc__glow--2" />
      </div>

      <div className="ovit-proc__container">
        <header className="ovit-proc__header">
          <h2 className="ovit-proc__title">
            Nuestro <span>Proceso</span>
          </h2>
          <p className="ovit-proc__subtitle">
            Un sistema simple y repetible para generar mensajes y convertirlos en clientes.
          </p>
        </header>

        <div className="ovit-proc__timeline">
          {steps.map((s) => (
            <article className="ovit-procStep" key={s.num}>
              <div className="ovit-procStep__top">
                <div className="ovit-procStep__num">{s.num}</div>
                <div className="ovit-procStep__icon" aria-hidden="true">
                  {s.icon}
                </div>
              </div>

              <h3 className="ovit-procStep__title">{s.title}</h3>
              <p className="ovit-procStep__desc">{s.desc}</p>

              <ul className="ovit-procStep__list">
                {s.bullets.map((b) => (
                  <li key={b}>
                    <span className="ovit-procStep__dot" aria-hidden="true" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="ovit-proc__cta">
          <div className="ovit-proc__ctaCard">
            <div className="ovit-proc__ctaTitle">
              ¿Listo para arrancar con un plan?
            </div>
            <div className="ovit-proc__ctaText">
              Elige tu plan ideal y lo ponemos a trabajar desde esta semana.
            </div>

            <div className="ovit-proc__ctaActions">
              <a className="ovit-proc__btn" href="#planes">
                Ver planes
              </a>
              <a className="ovit-proc__btn ovit-proc__btn--ghost" href="https://wa.me/525588093678?text=Hola,%20me%20interesa%20recibir%20informaci%C3%B3n%20sobre%20sus%20servicios%20de%20marketing%20digital.%20Quiero%20hacer%20crecer%20mi%20negocio%20y%20generar%20m%C3%A1s%20clientes." target="_blank" rel="noopener noreferrer">
                Hablar por WhatsApp
              </a>
            </div>

            <div className="ovit-proc__ctaNote">
              *Sin vueltas: estrategia → creativos → campañas → optimización.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcesoContenidoAds;